export const groupOptionScope1 = [
  { id: 1, name: "รถยนต์" },
  { id: 2, name: "รถโฟล์คลิฟท์" },
  { id: 3, name: "รถไถหญ้า" },
  { id: 4, name: "อื่นๆ (โปรดระบุ)" },
];

export const groupOptionScope2 = [
  { id: 1, name: "การไฟฟ้านครหลวง" },
  { id: 2, name: "การไฟฟ้าส่วนภูมิภาค" },
  { id: 3, name: "พลังงานโซลาร์เซลล์" },
  { id: 4, name: "อื่นๆ (โปรดระบุ)" },
];

export const groupOptionScope3 = [
  {
    id: 1,
    scope: {
      name: "scope 3.1",
      type: "scope3_1",
    },
    name: "การซื้อสินค้าและบริการ",
    lists: [],
    subScope: [
      {
        id: 1,
        scope: {
          name: "scope 3.1.1",
          type: "scope3_1_1",
        },
        name: "การใช้น้ำประปา",
        lists: [
          { id: 1, name: "ประปานครหลวง" },
          { id: 2, name: "ประปาส่วนภูมิภาค" },
          { id: 3, name: "น้ำบาดาล" },
          { id: 4, name: "อื่นๆ (โปรดระบุ)" },
        ],
      },
      {
        id: 2,
        scope: {
          name: "scope 3.1.2",
          type: "scope3_1_2",
        },
        name: "สินค้าและบริการอื่นๆ",
        lists: [],
      },
    ],
  },
  {
    id: 2,
    scope: {
      name: "scope 3.2",
      type: "scope3_2",
    },
    name: "Capital Goods",
    lists: [],
    subScope: [],
  },
  {
    id: 3,
    scope: {
      name: "scope 3.3",
      type: "scope3_3",
    },
    name: "การได้มา",
    lists: [],
    subScope: [],
  },
  {
    id: 4,
    scope: {
      name: "scope 3.4",
      type: "scope3_4",
    },
    name: "การขนส่งจากการซื้อสินค้า/วัตถุดิบ เพื่อนำมาใช้ในกระบวนการผลิตขององค์กร",
    lists: [],
    subScope: [],
  },
  {
    id: 5,
    scope: {
      name: "scope 3.5",
      type: "scope3_5",
    },
    name: "การกำจัดขยะ",
    lists: [
      {
        id: 1,
        name: "ขยะทั่วไป (General Waste)",
      },
      {
        id: 2,
        name: "ขยะรีไซเคิล (Recyclable Waste)",
      },
      {
        id: 3,
        name: "ขยะอินทรีย์ (Compostable Waste)",
      },
      {
        id: 4,
        name: "ขยะอันตราย (Hazardous Waste)",
      },
      {
        id: 5,
        name: "อื่นๆ (โปรดระบุ)",
      },
    ],
    subScope: [],
  },
  {
    id: 6,
    scope: {
      name: "scope 3.6",
      type: "scope3_6",
    },
    name: "การเดินทางเพื่อธุรกิจ",
    lists: [
      {
        id: 1,
        name: "รถยนต์ส่วนบุคคล",
      },
      {
        id: 2,
        name: "เครื่องบิน",
      },
      {
        id: 3,
        name: "อื่นๆ (โปรดระบุ)",
      },
    ],
    subScope: [],
  },
  {
    id: 7,
    scope: {
      name: "scope 3.7",
      type: "scope3_7",
    },
    name: "การเดินทางมาทำงานของพนักงาน",
    lists: [],
    subScope: [],
  },
  {
    id: 8,
    scope: {
      name: "scope 3.8",
      type: "scope3_8",
    },
    name: "การเช่าสินทรัพย์",
    lists: [],
    subScope: [],
  },
  {
    id: 9,
    scope: {
      name: "scope 3.9",
      type: "scope3_9",
    },
    name: "การขนส่งสินค้า/วัตถุดิบขององค์กรไปยังผู้รับปลายทาง",
    lists: [],
    subScope: [],
  },
  {
    id: 10,
    scope: {
      name: "scope 3.10",
      type: "scope3_10",
    },
    name: "การแปรรูปสินค้าที่องค์กรจำหน่าย",
    lists: [],
    subScope: [],
  },
  {
    id: 11,
    scope: {
      name: "scope 3.11",
      type: "scope3_11",
    },
    name: "การใช้งานของผลิตภัณฑ์ที่องค์กรจำหน่าย",
    lists: [],
    subScope: [],
  },
  {
    id: 12,
    scope: {
      name: "scope 3.12",
      type: "scope3_12",
    },
    name: "การกำจัดซากผลิตภัณฑ์ที่องค์กรจำหน่าย",
    lists: [],
    subScope: [],
  },
  {
    id: 13,
    scope: {
      name: "scope 3.13",
      type: "scope3_13",
    },
    name: "การปล่อยเช่าสินทรัพย์",
    lists: [],
    subScope: [],
  },
  {
    id: 14,
    scope: {
      name: "scope 3.14",
      type: "scope3_14",
    },
    name: "แฟรนไชส์",
    lists: [],
    subScope: [],
  },
  {
    id: 15,
    scope: {
      name: "scope 3.15",
      type: "scope3_15",
    },
    name: "การถือหุ้นองค์กรอื่นๆ",
    lists: [],
    subScope: [],
  },
];

export const groupOptionRefrigerant = [
  { id: 1, name: "R-22" },
  { id: 2, name: "R-32" },
  { id: 3, name: "R-410A" },
  { id: 4, name: "R-134A" },
  { id: 5, name: "R-515B" },
  { id: 6, name: "R-407C" },
  { id: 7, name: "R-404A" },
  { id: 8, name: "R-401A" },
  { id: 9, name: "R-417A" },
  { id: 10, name: "R-417C" },
  { id: 11, name: "R-452B" },
  { id: 12, name: "R-452A" },
];

export const groupOptionPosition = [
  { id: 1, name: "กรรมการบริหาร" },
  { id: 2, name: "ผู้จัดการโรงงาน" },
  { id: 3, name: "เจ้าหน้าที่ DCC." },
  { id: 4, name: "เจ้าหน้าที่ความปลอดภัยในการทำงาน" },
  { id: 5, name: "บัญชี" },
];
